export default __webpack_public_path__ + "static/media/Tombraider.65f7e298.png";